const backendPort = import.meta.env.VITE_BACKEND_PORT || "50505"
const appOrigin = typeof window === "undefined" ? "http://localhost" : window.location.origin

export const BACKEND_URI =
  process.env.NODE_ENV === "development"
    ? `http://localhost:${backendPort}/api`
    : `${appOrigin}/api`
